
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlN as ObiOwnShipControlNElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-n.js';
 
 
 

 
 export const ObiOwnShipControlN = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-n',
   elementClass: ObiOwnShipControlNElement,
   events: {
     
   }
  });
 
 